














import Vue from 'vue'
import ProductCard1 from './cardtemplates/ProductCard1.vue'
import ProductCard2 from './cardtemplates/ProductCard2.vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    ProductCard1,
    ProductCard2
  }
})
export default class ProductOverview extends Vue {
  @Prop({ type: Array })
  products!: []
}
